import { render, staticRenderFns } from "./POSTable.vue?vue&type=template&id=4d318ddb&"
import script from "./POSTable.vue?vue&type=script&lang=js&"
export * from "./POSTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports